import request from '../../libs/request';

const callMeAPI = (body, route, token, siteId) => request(`api/v1/${siteId}/meLigue${route}`).post({ body, token });

export default callMeAPI;
